
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { getCustomerLogos } from '@hokify/shared-components/lib/helpers/logos';
import type { IAPILogo } from '@hokify/shared-components/lib/helpers/logos';
import SectionStyling from '~/mixins/SectionStyling';

@Component({
	name: 'LogosSection'
})
export default class LogosSection extends Mixins(SectionStyling) {
	@Prop({ type: Array, required: false }) readonly customLogos!: IAPILogo[];

	@Prop({ type: Boolean }) readonly ssr!: boolean;

	@Prop({
		type: String,
		required: false,
		default: 'center',
		validator: (value: string) => ['center', 'left', 'top'].includes(value)
	})
	readonly align!: string;

	get alignClasses(): string {
		switch (this.align) {
			case 'left':
				return 'mt-2 mr-3';
			case 'top':
				return 'mt-2 mx-2 sm:mx-4';
			case 'center':
			default:
				return 'mt-6 mx-2 sm:mx-4';
		}
	}

	get logos(): IAPILogo[] {
		if (this.customLogos && this.customLogos.length > 0) {
			return this.customLogos;
		}
		if (this.$isMobile.phone) {
			return getCustomerLogos(this.$store.state.topLevelDomain).slice(0, 10);
		}

		return getCustomerLogos(this.$store.state.topLevelDomain);
	}
}
